<template>
  <div class="tusgaiZuvshuurul">
    <div class="container">
      <div class="tusgaiZuvshuurul_top">
        <div class="row">
          <div class="col-md-4">
            <div class="left">
              <h3>Тусгай зөвшөөрөл</h3>
            </div>
          </div>
          <div class="col-md-8">
            <div class="right">
              <div class="search-input">
                <Input  v-model="searchWord" @on-search="calldata"  search enter-button placeholder="Хайх..."/>
              </div>


              <!--                            <div class="row">-->
              <!--                                <div class="col-md-7">-->
              <!--                                    <div class="search-input">-->
              <!--                                        <Input search placeholder="Хайх..."/>-->
              <!--                                    </div>-->
              <!--                                </div>-->
              <!--                                <div class="col-md-5">-->
              <!--                                    <div class="pagenation">-->
              <!--                                        <Page :total="40"  />-->
              <!--                                    </div>-->
              <!--                                </div>-->
              <!--                            </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="tusgaiZuvshuurul_table">
        <div class="row">
          <div class="col-md-12">
            <table width="100%">
              <thead>
              <tr>
                <th>БҮРТГЭЛИЙН <br>ДУГААР</th>
                <th>СУРГАЛТЫН БАЙГУУЛЛАГЫН НЭР</th>
                <th>ТУШААЛЫН ДУГААР</th>
                <th>ОЛГОСОН ОГНОО</th>
                <th>ХҮЧИНТЭЙ ОГНОО</th>
                <th>ХАЯГ</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="index" v-for="(lis, index) in list">
                <td>{{ lis.burtgel_dugaar }}</td>
                <td>{{ lis.school_title }}</td>
                <td>{{ lis.tushaal_dugaar }}</td>
                <td>{{ lis.ologson_ogno | date}}</td>
                <td>{{ lis.huchintei_ogno | date }}</td>
                <td>
                  <Tooltip max-width="300" :content="lis.hayg">
                    <div class="hayg">
                      <i class="fa fa-map-marker"></i>
                    </div>
                  </Tooltip>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
         <span class="total-info">
            Нийт: <b>{{ total }}</b>
         </span>
        </div>
        <div class="col-md-9">
          <div class="pagenation">
            <Page @on-change="changePageTusgai"
                  :current-page="current_page"
                  :page-size="9"
                  :total="total"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getTusgaiZovshoorol} from "../api/index"

export default {

  components: {},
  data() {
    return {
      list: [],
      current_page: 1,
      last_page: 1,
      total: 0,
      searchWord: null,
      columns1: [
        {
          title: 'ДУГААР',
          key: 'dugaar',
          className: 'title_color',
          width: 100,
        },
        {
          title: 'АЙМАГ / ХОТ',
          key: 'aimag',
          width: 130,
        },
        {
          title: 'СУРГАЛТЫН ТӨРӨЛ',
          key: 'turul'
        },
        {
          title: 'ШИЙДВЭРИЙН ДУГААР',
          key: 'shiidveriinDugaar',
          className: 'main_color',
        },
        {
          title: 'БАЙГУУЛЛАГА',
          key: 'baiguullaga'
        },
        {
          title: 'ЭХЛЭХ ОГНОО',
          key: 'startDate',
          width: 120,
        },
        {
          title: 'ДУУСАХ ОГНОО',
          key: 'endDate',
          width: 130,
        },
        {
          title: 'ХАЯГ',
          key: 'hayg',
          width: 80,
          align: 'center'
        },
      ],
      data1: [
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
        {
          dugaar: '211/2018',
          aimag: 'Улаанбаатар',
          turul: 'СӨББ-ын туслах ажилтан',
          shiidveriinDugaar: 'A/85',
          baiguullaga: 'Аксэс-Сафа сургалтын төв',
          startDate: '2018-05-01',
          endDate: '2020-05-01',
          hayg: '2020-05-01',
        },
      ]
    }
  },
  mounted() {
    this.calldata();
  },
  methods: {

    calldata() {
      this.$isLoading(true);
      getTusgaiZovshoorol(this.current_page, {
        searchWord: this.searchWord
      }).then(response => {
        this.list = response.data.data;
        this.current_page = response.data.current_page;
        this.total = response.data.total;
        // console.log(response.data);
        // console.log(this.current_page);
        this.$isLoading(false);
      }).catch(error => {
        this.$Loading.error();
        console.log('ErrorL ', error);
      });
    },
    changePageTusgai(page) {
      this.current_page = page;
      this.calldata();
    },
  },
}
</script>
